import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-exclusions',
  templateUrl: './exclusions.component.html',
  styleUrls: ['./exclusions.component.scss']
})
export class ExclusionsComponent implements OnInit, OnChanges  {
  @Input() details: any = {};

  exclusions: any[] = [];

  private defaultExclusions = [
    "The following services are not included in the plan and you are responsible for payment of the dentist's normal fees for these services:",
    "Services provided by a dentist who is not participating in the plan.",
    "Procedures deemed not reasonably necessary or not customarily performed, including, but not limited to services that have a poor prognosis and duplicate prosthetic devices or appliances, as determined by the dentist.",
    "Anesthesiologist services.",
    "Treatment of jaw fractures or dislocations, congenital or developmental malformations, malignancies, cysts or neoplasms, or Temporomandibular Joint Syndrome (TMJ).",
    "Courses of treatment which began prior to the effective date of your plan and/or expenses incurred after termination of your plan.",
    "Any dental disease, defect or injury that arises out of any occupational incident or exposure for which you can receive benefits under applicable workers' compensation law.",
    "Services of a specialist, including specialty X-rays such as a CBCT's.",
    "Cleaning types are determined by the diagnosis of the General Practitioner. Prophylaxis benefits are excluded in the presence of periodontal disease"
  ];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    const detailsChange: SimpleChange = changes['details'];
    if (detailsChange && detailsChange.currentValue) {
      this.updateExclusions();
    }
  }

  ngOnInit(): void {
    this.updateExclusions();
  }

  private updateExclusions(): void {
    if (this.details?.salesPlanMarketingDetails?.exclusion && this.details.salesPlanMarketingDetails.exclusion.length > 0) {
      // Use dynamic exclusions from marketing data
      this.exclusions = [...this.defaultExclusions, ...this.details.salesPlanMarketingDetails.exclusion[0].value.map((item: any) => item.column1)]
    } else {
      // Use default exclusions
      this.exclusions = this.defaultExclusions;
    }
  }

}